import React, { createContext, memo, useContext, useState } from 'react';
import Player from 'video.js/dist/types/player';
import { Observable, register, useObservable } from '../utils/Observable';

const events = ['ended', 'durationchange', 'timeupdate'];

class PlayerControl extends Observable<Player> {
    scrubTime: Observable<number>;
    constructor() {
        super();
        this.scrubTime = new Observable<number>();
        this.updateScrubTime = this.updateScrubTime.bind(this);
        this.add((newPlayer, oldPlayer) => {
            oldPlayer?.off(events, this.updateScrubTime);
            newPlayer?.on(events, this.updateScrubTime);
            this.updateScrubTime();
        });
    }
    updateScrubTime() {
        this.scrubTime.set(this.value?.currentTime());
    }
}

const PlayerControlContext = createContext<PlayerControl | null>(null);

function usePlayerControl() {
    const ctx = useContext(PlayerControlContext);
    if (!ctx) {
        throw new Error('player outside of context');
    }
    return ctx;
}

export const PlayerContext = memo(
    ({ children }: { children?: React.ReactNode }) => {
        const [control] = useState(() => new PlayerControl());
        return (
            <PlayerControlContext.Provider value={control}>
                {children}
            </PlayerControlContext.Provider>
        );
    }
);

export const usePlayer = () => useObservable(usePlayerControl());

export const usePlayerScrubtime = () =>
    useObservable(usePlayerControl().scrubTime);

export const registerPlayer = (player?: Player) =>
    register(usePlayerControl(), player);
